module.exports = __webpack_public_path__ + "static/media/6.7d51f04e.svg";